import { render, staticRenderFns } from "./merchantWithdrawRouter.vue?vue&type=template&id=4e666244"
import script from "./merchantWithdrawRouter.vue?vue&type=script&lang=js"
export * from "./merchantWithdrawRouter.vue?vue&type=script&lang=js"
import style0 from "./merchantWithdrawRouter.vue?vue&type=style&index=0&id=4e666244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports